import styled from 'styled-components';

export const JobRightRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 10px;
`;
